<div class="row h-100 m-0 playerladder">
    <!-- player Ladder  -->
    <div class="col-lg-7">
        <app-player-ladder-board></app-player-ladder-board>
    </div>
    <!--team Ladder  -->
    <div class="col-lg-5">
        <app-team-ladder-board></app-team-ladder-board>
    </div>
  </div>